import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslations } from "next-intl";
import { toast } from "sonner";
import { fetchClient } from "@/lib/api-client";

interface SubmitArgs {
  content: string;
  parent_id?: string;
}

export const useSubmitBlogComment = (slug: string) => {
  const t = useTranslations("blog");
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ content, parent_id }: SubmitArgs) => {
      const response = await fetchClient.POST("/blog/{slug}/comments", {
        params: { path: { slug } },
        body: { content, parent_id },
      });
      const err = (response as { error?: unknown }).error;
      if (err) throw err;
      return response.data;
    },
    onSuccess: (_data, vars) => {
      toast.success(t("toasts.submitted"));
      if (vars.parent_id) {
        qc.invalidateQueries({
          queryKey: ["blog-comment-replies", vars.parent_id],
        });
      }
    },
    onError: () => toast.error(t("toasts.error")),
  });
};
